<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Layout from '@/layout/index'
export default {
  name: 'App',
  components:{
    Layout
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue